import React, {Component} from 'react'
import {
  Row,
  Col,
  Button,
  Select,
  Radio,
  Spin,
  DatePicker
} from 'antd';
import moment from 'moment'
import {SUB_CATEGORY_POWER_METER_DAY, SUB_CATEGORY_POWER_METER_MONTH, SUB_CATEGORY_POWER_METER_COUNTER} from '../constants/defaultValues'
import {getDateConverterSimple} from '../utils'
const dateFormat = 'YYYY-MM-DD'
const {RangePicker} = DatePicker
const Option = Select.Option
const RadioButton = Radio.Button
const RadioGroup = Radio.Group

class StationDeviceDatasToolbar extends Component {
  constructor(props) {
    super(props);
    const {device, timeQuery, from, to} = this.props
    const deviceID = device && device.DeviceId
      ? device.DeviceId
      : undefined
    this.state = {
      timeQuery: timeQuery,
      deviceSelected: deviceID,
      deviceSelectedObj: device,
      from: from,
      to: to
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.device) {
      this.setState({deviceSelected: nextProps.device.DeviceId, timeQuery: nextProps.timeQuery, from: nextProps.from, to: nextProps.to})
    }
  }

  handleDeviceChange = (value) => {
    const {devices} = this.props
    const obj = devices.find((dev) => dev.DeviceId === value);
    const crrTimeUnix = new Date().getTime() / 1000;
    let from = getDateConverterSimple(crrTimeUnix)
    let to = getDateConverterSimple(crrTimeUnix)
    let timeQuery = 'day'
    if (obj.SubCategory === SUB_CATEGORY_POWER_METER_DAY) {
      from = getDateConverterSimple(crrTimeUnix - (30 * 24 * 60 * 60)),
      to = getDateConverterSimple(crrTimeUnix)
      timeQuery = 'month'
    } else if (obj.SubCategory === SUB_CATEGORY_POWER_METER_MONTH) {
      from = getDateConverterSimple(crrTimeUnix - (365 * 24 * 60 * 60)),
      to = getDateConverterSimple(crrTimeUnix)
      timeQuery = 'year'
    }
    this.setState({
      deviceSelected: value,
      deviceSelectedObj: obj,
      from: from,
      to: to,
      timeQuery: timeQuery,
      dayDisable: obj.SubCategory === SUB_CATEGORY_POWER_METER_DAY
        ? true
        : false
    });
    this.props.onSearch(timeQuery, from, to, value)
  }

  handleTimeChange = (e) => {
    const value = e.target.value
    const crrTimeUnix = new Date().getTime() / 1000;
    let from = ''
    let to = ''
    if (value === 'week') {
      from = getDateConverterSimple(crrTimeUnix - (7 * 24 * 60 * 60)),
      to = getDateConverterSimple(crrTimeUnix)
    } else if (value === 'month') {
      from = getDateConverterSimple(crrTimeUnix - (30 * 24 * 60 * 60)),
      to = getDateConverterSimple(crrTimeUnix)
    } else if (value === 'year') {
      from = getDateConverterSimple(crrTimeUnix - (365 * 24 * 60 * 60)),
      to = getDateConverterSimple(crrTimeUnix)
    } else {
      from = getDateConverterSimple(crrTimeUnix),
      to = getDateConverterSimple(crrTimeUnix)
    }
    this.setState({from: from, to: to, timeQuery: value});
    this.props.onSearch(value, from, to, this.state.deviceSelected)
  }

  handleRangePickerChange = (dates, dateStrs) => {
    if (dateStrs[0] === "" && dateStrs[1] === "") {
      this.setState({
        timeQuery: 'day',
        from: getDateConverterSimple(new Date().getTime() / 1000),
        to: getDateConverterSimple(new Date().getTime() / 1000)
      })
    } else {
      this.props.onSearch('', dateStrs[0], dateStrs[1], this.state.deviceSelected)
      this.setState({timeQuery: '', from: dateStrs[0], to: dateStrs[1]})
    }
  }

  handleExport = () => {
    const {deviceSelected, timeQuery, from, to} = this.state
    this.props.onExport(deviceSelected, timeQuery, from, to)
  }

  render() {
    const {devices, fetching} = this.props
    const {from, to, timeQuery, deviceSelected, deviceSelectedObj} = this.state
    const yearHidden = deviceSelectedObj.SubCategory === SUB_CATEGORY_POWER_METER_MONTH
      ? false
      : true
    const dayDisable = deviceSelectedObj.SubCategory === SUB_CATEGORY_POWER_METER_DAY
      ? true
      : false

    const miniDevices = devices.filter((dev) => {
      return dev.SubCategory !== SUB_CATEGORY_POWER_METER_COUNTER
    })

    return (<Row type="flex" justify="end">
      <Col xs={{
          span: 24
        }} sm={{
          span: 14,
          pull: 1
        }} md={{
          span: 14,
          pull: 1
        }} lg={{
          span: 14,
          pull: 1
        }} xl={{
          span: 8,
          pull: 2
        }}>
        <Select style={{
            width: '100%'
          }} notFoundContent={fetching
            ? <Spin size="small"/>
            : null} placeholder="Chọn thiết bị" onChange={this.handleDeviceChange} defaultValue={deviceSelected}>
          {
            miniDevices.map((dev, i) => {
              const roomName = dev.RoomName !== "Default"
                ? dev.RoomName.toLowerCase()
                : ""
              const deviceName = dev.Name !== ""
                ? dev.Name
                : ""
              const title = `${deviceName} ${roomName}`
              return <Option value={dev.DeviceId} key={i + 1}>{title}</Option>
            })
          }
        </Select>
      </Col>

      <Col xs={{
          span: 24
        }} sm={{
          span: 9
        }} md={{
          span: 9
        }} lg={{
          span: 9
        }} xl={{
          span: 6,
          pull: 2
        }}>
        <RadioGroup value={timeQuery} onChange={this.handleTimeChange}>
          <RadioButton value="day" disabled={!yearHidden || dayDisable}>ngày</RadioButton>
          <RadioButton value="week" disabled={!yearHidden}>tuần</RadioButton>
          <RadioButton value="month" disabled={!yearHidden}>tháng</RadioButton>
          {
            !yearHidden
              ? <RadioButton value="year">năm</RadioButton>
              : null
          }
        </RadioGroup>
      </Col>
      <Col xs={{
          span: 24
        }} sm={{
          span: 14,
          pull: 7
        }} md={{
          span: 14,
          pull: 7
        }} lg={{
          span: 14,
          pull: 7
        }} xl={{
          span: 6,
          pull: 1
        }}>
        <RangePicker value={[
            moment(from, dateFormat),
            moment(to, dateFormat)
          ]} style={{
            width: '100%'
          }} placeholder={['Từ ngày', 'Đến ngày']} format={dateFormat} onOk={this.handleRangePickerOk} onChange={this.handleRangePickerChange}/>
      </Col>
      <Col xs={{
          span: 12
        }} sm={{
          span: 3,
          pull: 1
        }} md={{
          span: 3,
          pull: 0
        }} lg={{
          span: 3,
          pull: 0
        }} xl={{
          span: 2
        }}>
        <Button icon="file-excel" className="btn-excel" onClick={this.handleExport} disabled={fetching}>Excel</Button>
      </Col>
    </Row>);
  }
}

export default StationDeviceDatasToolbar;



// WEBPACK FOOTER //
// ./src/components/StationDeviceDatasToolbar.js